import React from 'react'
import Avatar from '@material-ui/core/Avatar'
import MissingAvatar from 'url:./assets/agent-profile-large-invite.svg'

function AgentAvatar (props) {
  const avatarUrl = props.avatarUrl ? props.avatarUrl : MissingAvatar
  const size = props.size ? props.size : 30
  const avatarClasses = {}

  return (
    <Avatar src={avatarUrl} style={{ height: size, width: size }} classes={avatarClasses} />
  )
}

export default AgentAvatar
